import { Layout } from "antd";
import { Helmet } from "react-helmet";
import { GeneralStore } from "../stores";
import { Link, Outlet } from "react-router-dom";
import { Footer, Header } from "antd/es/layout/layout";
import { Title, Sidebar, MobileSidebar } from ".";
const { Content } = Layout;

export const MainLayout = () => {
  const { pageTitle, contentPadding } = GeneralStore();
  return (
    <>
      <Helmet>
        <html className="m-0 p-0" />
        <body className="min-h-screen duration-300  w-full !m-0  overflow-x-hidden  !p-0  box-border" />
        <title>{pageTitle && pageTitle + " - "} Spor Konya</title>
      </Helmet>
      <Layout className="min-h-screen !m-0 !p-0 bg-[#f5f5f0]">
        <MobileSidebar />
        <Sidebar />
        <Layout>
          <div className="sticky top-0 z-[1000] bg-[#f5f5f0]">
            <Title />
          </div>
          <Content className="mx-2 relative  min-h-[75vh] border border-gray-200 rounded-lg">
            <div
              className={`${
                contentPadding && "p-3 md:py-6 md:px-8"
              }  bg-white rounded-lg overflow-y-auto h-full`}
            >
              <Outlet />
            </div>
          </Content>
          <Footer className="text-center leading-6">
            Spor Konya {new Date().getFullYear()} © <br />
            <Link
              className="text-primary"
              target="_blank"
              to="https://sehirteknolojileri.com/"
            >
              Şehir Teknolojileri Merkezi{" "}
            </Link>
            tarafından yapıldı.
          </Footer>
        </Layout>
      </Layout>
    </>
  );
};
